import React from "react";
import { Tooltip } from "@mui/material";

const CustomTooltip = ({ title, placement = "top", children }) => {
  return (
    <Tooltip
      title={title}
      arrow
      placement={placement}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: "background.errorBlack",
            color: "text.white",
            fontSize: "12px",
            padding: "6px 12px",
            borderRadius: "8px",
          },
        },
        arrow: {
          sx: {
            color: "background.errorBlack",
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
